import React, { useEffect } from 'react'
import {
  Typography,
  Box,
  CircularProgress,
} from '@mui/material'
import { SidebarLayout } from '@/components/Layout'
import { useAuth } from '@/contexts/AuthContext'
import { useNavigate } from 'react-router-dom'

export default function Bookings() {
  const { userProfile } = useAuth()
  const navigate = useNavigate()
  
  // Redirect to appropriate page based on user role
  useEffect(() => {
    if (userProfile) {
      const isHost = userProfile.roles.includes('host')
      if (isHost) {
        // Hosts should go to My Bookings (property management)
        navigate('/my-bookings', { replace: true })
      } else {
        // Guest-only users should go to My Trips
        navigate('/my-trips', { replace: true })
      }
    }
  }, [userProfile, navigate])

  // Show loading while redirecting
  return (
    <SidebarLayout>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
        <Typography variant="body1" sx={{ ml: 2 }}>
          Redirecting...
        </Typography>
      </Box>
    </SidebarLayout>
  )
}